import React from "react";
import ReactDOM from "react-dom/client";
import "leaflet/dist/leaflet.css";
import App from "./App";
import "./styles.css";
import {
  buildTelemetryContext,
  initTelemetry,
  setTelemetryUserIdentity,
  TELEMETRY_EVENTS,
  trackTelemetry
} from "./utils/telemetry";
import { loadOrCreateUserId } from "./utils/storage";

const anonymousUserId = loadOrCreateUserId();
initTelemetry();
setTelemetryUserIdentity(anonymousUserId);

const trackRuntimeEvent = (eventName: typeof TELEMETRY_EVENTS.RUNTIME_ONLINE | typeof TELEMETRY_EVENTS.RUNTIME_OFFLINE) => {
  trackTelemetry(
    eventName,
    buildTelemetryContext({ anonymousUserId, sessionId: null })
  );
};

if (typeof window !== "undefined") {
  window.addEventListener("online", () => {
    trackRuntimeEvent(TELEMETRY_EVENTS.RUNTIME_ONLINE);
  });
  window.addEventListener("offline", () => {
    trackRuntimeEvent(TELEMETRY_EVENTS.RUNTIME_OFFLINE);
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(() => {
        trackTelemetry(
          TELEMETRY_EVENTS.SERVICE_WORKER_REGISTERED,
          buildTelemetryContext({ anonymousUserId, sessionId: null })
        );
      })
      .catch(() => {
        trackTelemetry(
          TELEMETRY_EVENTS.SERVICE_WORKER_REGISTRATION_FAILED,
          {
            ...buildTelemetryContext({ anonymousUserId, sessionId: null }),
            error_kind: "registration_failed"
          }
        );
        // Ignore registration failures to keep the app functional.
      });
  });
}
